module.exports = __webpack_public_path__ + "static/media/organization-office-building-work.b83a3577.svg";